import { get } from 'lodash'
import React, { useContext } from 'react'
import styled, { createGlobalStyle } from 'styled-components'
import images from '../images'
import ActionsContext from '../ActionsContext'
import Language from './Language'
import Theme from './Theme'
import { getLanguageStore, clearLoginCookie } from '../storage'
import Divider from '../../divider'
import Popover from '../../popover'
import Row from '../../row'

const Avatar = styled.li`
  margin-right: 0;
  font-size: 0;
  img {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    cursor: pointer;
    .large-size & {
      width: 32px;
      height: 32px;
    }
  }
`

const GlobalStyle = createGlobalStyle`
    .tnt-layout-personal-popover {
        .ant-popover-inner-content {
            padding: 0;
        }
    }
`

const UserInfoWrapper = styled.div`
  width: 330px;
  z-index: 1;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
  .isInIframe & {
    display: none;
  }

  .user-info-body {
    padding: 20px 15px;
    line-height: 16px;
    list-style: none;
    margin: 0;
    .user-info-body-username {
      margin-top: 0px;
      font-family: PingFangSC-Regular;
      font-weight: normal;
      font-size: 14px;
      color: ${(props) => `${props.theme.primaryTextColor}`};
      line-height: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .user-info-body-account {
      margin-top: 0px;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #8b919e;
      margin-bottom: 14px;
      line-height: 14px;
      margin-left: 10px;
    }
  }
  .user-info-footer {
    border-top: ${(props) => `1px solid ${props.theme.dividerColor}`};
    background-color: #fff;
    height: 36px;
    line-height: 36px;
    padding: 0 15px;
    font-size: 12px;
    color: ${(props) => `${props.theme.primaryColor}`};
    a {
      flex: 1;
      text-align: center;
      color: ${(props) => `${props.theme.primaryColor}`};
    }
  }
`

const UserInfoContent = (props) => {
  const {
    userInfo,
    config = {},
    onLogout,
    onChangePassword = () => true,
    onPersonalSetting = () => true,
    onLanguageChange,
    onThemeChange,
  } = props
  const { getText } = useContext(ActionsContext)
  const { language = true } = config || {}
  return (
    <UserInfoWrapper className="user-info-setting-wrap">
      <ul className="user-info-body">
        <li className="user-info-body-username">
          {userInfo.userName || getText('nameNull')}
          <span className="user-info-body-account">{userInfo.account}</span>
        </li>
        {language && <Language language={userInfo.lang} onChange={onLanguageChange} />}
        <Theme theme={userInfo.theme} onChange={onThemeChange} />
      </ul>
      <Row className="user-info-footer" type="flex" justify="space-between" align="middle">
        <a onClick={onPersonalSetting} href="/bridge/userCenter?currentTab=1">
          {getText('personalSettings')}
        </a>
        <Divider type="vertical" />
        <a
          onClick={onChangePassword}
          href="/bridge/userCenter?currentTab=2"
          style={getLanguageStore() === 'en' ? { flex: 2 } : {}}
        >
          {getText('changePwd')}
        </a>
        <Divider type="vertical" />
        <a
          className="user-info-footer-signout"
          onClick={() => {
            if (onLogout) {
              onLogout()
              clearLoginCookie()
            } else {
              clearLoginCookie()
              window.location.href = `/user/login?callbackUrl=${window.encodeURI(location.href)}`
            }
          }}
        >
          {getText('signOut')}
        </a>
      </Row>
    </UserInfoWrapper>
  )
}

export default (props) => {
  const { userInfo = {} } = props
  const { avatar } = userInfo

  return (
    <Avatar>
      <Popover
        popupClassName="tnt-layout-personal-popover"
        placement="bottomRight"
        title={null}
        content={<UserInfoContent {...props} />}
        trigger="click"
      >
        {avatar ? (
          <img
            src={
              avatar.indexOf('base64') > 0 ? avatar : get(images[avatar], 'default', images[avatar])
            }
            onError={(e) => {
              e.target.onerror = null
              e.target.src = images.empty?.default || images.empty
            }}
          />
        ) : (
          <img src={images.empty?.default || images.empty} />
        )}
      </Popover>
      <GlobalStyle />
    </Avatar>
  )
}
